import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = { class: "app-container" };
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { mapping_Name_To_Title } from "@/router/title";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const include = ref([]);
        const route = useRoute();
        const router = useRouter();
        window.reg_SubRouter__VueRouter(router, mapping_Name_To_Title);
        window.reg_SubRouter__VueApp(router, route, mapping_Name_To_Title);
        window.add_HeaderTabsChangeListener(res_include => {
            //@ts-ignore
            include.value = res_include.map((item) => mapping_RouterPath_To_Name(item.sub_route_path));
        });
        function mapping_RouterPath_To_Name(path) {
            var i = path.indexOf('?');
            console.log("mapping_RouterPath_To_Name", path);
            if (!~i) {
                // 无query参数
                return path.slice(path.lastIndexOf('/') + 1);
            }
            else {
                return path.slice(path.lastIndexOf('/', i) + 1, i);
            }
        }
        const global_style = ref(window.$wujie.props?.__SYSTEM_CONFIG__?.GLOBAL_STYLE || []);
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(global_style.value, (item) => {
                    return (_openBlock(), _createElementBlock("link", {
                        rel: "stylesheet",
                        href: item,
                        key: item
                    }, null, 8, _hoisted_1));
                }), 128)),
                _createVNode(_unref(ElConfigProvider), { locale: _unref(zhCn) }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_router_view, null, {
                                default: _withCtx(({ Component }) => [
                                    (_openBlock(), _createBlock(_KeepAlive, { include: include.value }, [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                                    ], 1032, ["include"]))
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    _: 1
                }, 8, ["locale"])
            ], 64));
        };
    }
});
